import etc_config from "./other_configuration";

let config = {
    website_url: process.env.VUE_APP_TREMBITA_WEBSITE_URL,
    catalog_url: process.env.VUE_APP_CATALOG_URL,
    backend_url: process.env.VUE_APP_BACKEND_URL,
    IDGOVUA: {
        url: process.env.VUE_APP_ID_GOV_UA_URL,
        client_id: process.env.VUE_APP_ID_GOV_UA_CLIENT_ID,
        state: 'catalog_auth',
        redirect_uri: process.env.VUE_APP_REDIRECT_URL,
    },
                 
    notification_duration: 10000,
    query_params: {},
    decoded_token: {},
    user_data: {},

    INFORMATION_RESOURCE_MAX_HEAD_PERSON_DOCUMENT_SIZE: 20000000,
    INFORMATION_RESOURCE_INTERFACE_DOCUMENTATION_MAX_FILE_SIZE: 20000000,

    INFORMATION_RESOURCE_HEAD_PERSON_ALLOWED_FORMATS: '.pdf, .jpg, .jpeg, .png',
    INFORMATION_RESOURCE_OPERATOR_LEGAL_BASIS_ALLOWED_FORMATS: '.pdf, .jpg, .jpeg, .png',
    INFORMATION_RESOURCE_INTERFACE_DOCUMENTATION_ALLOWED_FORMATS: '.pdf, .jpg, .jpeg, .png, .zip, .doc, .docx, .xlsx, .ppt',
};

Object.assign(config, etc_config);

export default config;